import React, { useEffect, useState } from "react";
import "./css/emi.css";
import constants from "../../../../Shared/constants/constants";

import swal from "sweetalert";
import emiAbi from "../../../../Shared/emiAbi.json";
import erc20Abi from "../../../../Shared/erc20Abi.json";
import BigNumber from "bignumber.js";
import Web3 from "web3";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const EmiDueToPay = (props) => {
    const [connectedWallet, setConnectedWallet] = useState(null);
    const [web3, setWeb3] = useState(null);
    const [isWalletConnected, setWalletConnected] = useState(false);
    const [minimumToPay, setMinimumToPay] = useState(10);
    const [isAlreadyApproved, setIsAlreadyApproved] = useState(false);
    const [isApprovedTxAvailable, setIsApprovedTxAvailable] = useState(false);
    const [isPayTxAvailable, setIsPayTxAvailable] = useState(false);
    const [approvedTx, setApprovedTx] = useState(null);
    const [payTx, setPayTx] = useState(null);

    const [collectionInfo, setCollectionInfo] = useState(props.collectionInfo);
    const [payingAmount, setPayingAmount] = useState(0);

    const [paymentToken, setPaymentToken] = useState(constants.PAY_TOKEN);
    const getWalletConnectionStatus = () => {
        let _wallet = cookies.get("wallet");
        let _wallet_status = cookies.get("wallet_status");
        if (_wallet_status == true || _wallet_status == "true") {
            setWalletConnected(true);
            setConnectedWallet(_wallet);
            setWeb3(window.web3);
        } else {
            setWalletConnected(false);
            setConnectedWallet(null);
            setWeb3(null);
        }
    };

    const choosePaymentTokenOptions = [
        {
            label: constants.PAY_TOKEN_NAME,
            value: constants.PAY_TOKEN,
        },
        {
            label: constants.PAY_TOKEN2_NAME,
            value: constants.PAY_TOKEN2,
        },
    ];

    const handleChange = (event) => {
        setPayingAmount(event.target.value);
        console.log(payingAmount);

        if (parseInt(payingAmount) > parseInt(collectionInfo.amountDue)) {
            setPayingAmount(collectionInfo.amountDue);
        } else {
            isNFTContractApproved(paymentToken);
        }
    };

    const handlePaymentTokensChange = (selectedPayToken) => {
        setPaymentToken(selectedPayToken.target.value);
    };

    const isNFTContractApproved = async (selectedPayToken) => {
        try {
            let web3 = new Web3(window.ethereum);

            let _wallet = cookies.get("wallet");
            let _wallet_status = cookies.get("wallet_status");
            if (_wallet_status == true || _wallet_status == "true") {
                setWalletConnected(true);
                setConnectedWallet(_wallet);
                setWeb3(window.web3);
            } else {
                setWalletConnected(false);
                setConnectedWallet(null);
                setWeb3(null);
            }

            console.log(
                `[nft][src][components][[pages]][EmiDueToPay] selectedToken`,
                selectedPayToken
            );
            if (
                selectedPayToken != "null" ||
                selectedPayToken != "0x0000000000000000000000000000000000000000"
            ) {
                let erc20 = await new web3.eth.Contract(
                    erc20Abi,
                    selectedPayToken
                );

                // balance to Pay
                let balanceToPay = new BigNumber(payingAmount);

                console.log(connectedWallet, constants.NITROMORTGAGE, "******");

                let isApproved = await erc20.methods
                    .allowance(connectedWallet, constants.NITROMORTGAGE)
                    .call();

                let decimal = await erc20.methods.decimals().call();

                let baseBN = new BigNumber(10);
                let decimalBN = new BigNumber(decimal);

                let exponentiate = baseBN.exponentiatedBy(decimalBN);

                let isApprovedBN = new BigNumber(isApproved);
                let balanceToPayBN = new BigNumber(balanceToPay).multipliedBy(
                    exponentiate
                );

                let res = isApprovedBN.comparedTo(balanceToPayBN);
                console.log(
                    `[nft][src][components][[pages]][EmiDueToPay] res`,
                    res
                );

                if (res === 0 || res == 1) {
                    setIsAlreadyApproved(true);
                } else if (res == -1) {
                    setIsAlreadyApproved(false);
                }
                console.log(
                    `[nft][src][components][pages][EmiOutstandingPay][isNFTContractApproved] Is Approved`,
                    isAlreadyApproved
                );
            } else {
                setIsAlreadyApproved(false);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const approveNFTContract = async () => {
        let web3 = new Web3(window.ethereum);
        let accounts = await web3.eth.getAccounts();

        if (web3 != null) {
            try {
                console.log(
                    "[nft][src][components][pages][EmiOutstandingPay][approveNFTContract] Initiated"
                );
                console.log(
                    "[nft][src][components][pages][EmiOutstandingPay][approveNFTContract] Selected Token to Pay",
                    paymentToken
                );

                let payToken = paymentToken;
                let contractToApprove = constants.NITROMORTGAGE;
                let valueToApprove =
                    "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff";

                let ERC20 = await new web3.eth.Contract(erc20Abi, payToken);

                try {
                    await ERC20.methods
                        .approve(contractToApprove, valueToApprove)
                        .send({ from: accounts[0] })
                        .on("transactionHash", function (hash) {
                            setIsApprovedTxAvailable(true);
                            swal({
                                icon: "info",
                                title: "In progress",
                                text: "Transaction initiated, please wait for the transaction to complete!",
                                showConfirmButton: true,
                                showCancelButton: false,
                                allowOutsideClick: false,
                            });
                            console.log(
                                "[nft][src][components][pages][EmiOutstandingPay][approveNFTContract] Approve Tx Hash",
                                hash
                            );
                            let txHash = `${constants.AVAX_EXPLORER}/tx/${hash}`;
                            setApprovedTx(txHash);
                            waitTransactionReceipt(
                                hash,
                                "approve",
                                0,
                                function (err, receipt) {
                                    if (err != null) {
                                        return;
                                    }
                                }
                            );
                        })
                        .on("error", function (error, receipt) {
                            console.log(
                                "[nft][src][components][pages][EmiOutstandingPay][approveNFTContract] Approve Tx Error",
                                error
                            );
                            swal({
                                icon: "error",
                                title: "Failed",
                                text: "Transaction cancelled. Please try again!",
                                showConfirmButton: true,
                                showCancelButton: false,
                                allowOutsideClick: true,
                            });
                            setIsAlreadyApproved(false);
                            return;
                        });
                } catch (error) {
                    console.log(
                        "[nft][src][components][pages][EmiOutstandingPay][approveNFTContract] Catch Error",
                        error
                    );
                    swal({
                        icon: "error",
                        title: "Failed",
                        text: "Something went wrong. Please try again!",
                        showConfirmButton: true,
                        showCancelButton: false,
                        allowOutsideClick: true,
                    });
                    setIsAlreadyApproved(false);
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    const waitTransactionReceipt = async (
        transactionHash,
        actionType,
        timeOut,
        callback
    ) => {
        console.log(
            "[nft][src][components][pages][EmiOutstandingPay][waitTransactionReceipt] transactionHash",
            transactionHash
        );
        var web3 = new Web3(window.ethereum);

        let timeOutCounter = 0;
        let err = {
            message: "",
        };

        let isWaitRunning = false;

        let getReceiptTimerId = setInterval(function () {
            if (isWaitRunning == false) {
                isWaitRunning = true;
                web3.eth
                    .getTransaction(transactionHash)
                    .then(function (tx) {
                        if (tx == null) {
                            clearInterval(getReceiptTimerId);
                            console.log(
                                `[nft][src][components][pages][EmiOutstandingPay][waitTransactionReceipt] transactionHash ${transactionHash} is not found`
                            );
                            err.message = "Transaction hash is not found.";
                            isWaitRunning = false;
                            if (callback) {
                                callback(err, null);
                            }
                            return;
                        }

                        if (tx.blockNumber == null) {
                            if (timeOut > 0) {
                                timeOutCounter++;
                                if (timeOutCounter >= timeOut) {
                                    clearInterval(getReceiptTimerId);
                                    isWaitRunning = false;
                                    err.message =
                                        "Timeout while waiting transaction to confirm.";
                                    if (callback) {
                                        callback(err, null);
                                    }
                                    return;
                                } else {
                                    console.log(
                                        `[nft][src][components][pages][EmiOutstandingPay][waitTransactionReceipt] transactionHash 1 ${transactionHash} is pending`
                                    );
                                    isWaitRunning = false;
                                    return;
                                }
                            } else {
                                console.log(
                                    `[nft][src][components][pages][EmiOutstandingPay][waitTransactionReceipt] transactionHash 2 ${transactionHash} is pending`
                                );
                                isWaitRunning = false;
                                return;
                            }
                        }

                        // Transaction confirm
                        web3.eth
                            .getTransactionReceipt(transactionHash)
                            .then(async function (web3TxReceipt) {
                                clearInterval(getReceiptTimerId);
                                isWaitRunning = false;
                                if (web3TxReceipt == null) {
                                    console.log(
                                        `[nft][src][components][pages][EmiOutstandingPay][waitTransactionReceipt] transactionHash 2 ${transactionHash} is not found`
                                    );
                                    swal({
                                        icon: "error",
                                        title: "Failed",
                                        text: "Transaction Failed. Please try again!",
                                        showConfirmButton: true,
                                        showCancelButton: false,
                                        allowOutsideClick: true,
                                    });
                                    setIsAlreadyApproved(false);
                                }
                                console.log(
                                    `[nft][src][components][pages][EmiOutstandingPay][waitTransactionReceipt] Transaction receipt ${transactionHash}: ${web3TxReceipt}`
                                );

                                if (actionType == "approve") {
                                    swal({
                                        icon: "success",
                                        title: "Approved",
                                        text: "Transaction Successful",
                                        showConfirmButton: true,
                                        showCancelButton: false,
                                        allowOutsideClick: false,
                                    });
                                    setIsAlreadyApproved(true);
                                } else if (actionType == "emi") {
                                    swal({
                                        icon: "success",
                                        title: "EMI Success",
                                        text: "NFM EMI payment Successful.",
                                        showConfirmButton: true,
                                        showCancelButton: false,
                                        allowOutsideClick: false,
                                    });
                                    refreshPage();
                                }
                            })
                            .catch(function (error) {
                                clearInterval(getReceiptTimerId);
                                isWaitRunning = false;
                                console.log(
                                    `[nft][src][components][pages][EmiOutstandingPay][waitTransactionReceipt] Error on transaction receipt 1 ${transactionHash}: ${error}`
                                );
                                swal({
                                    icon: "error",
                                    title: "Cancelled",
                                    text: error.message,
                                    showConfirmButton: true,
                                    showCancelButton: false,
                                    allowOutsideClick: true,
                                });
                                setIsAlreadyApproved(false);
                            });
                    })
                    .catch(function (error) {
                        clearInterval(getReceiptTimerId);
                        console.log(
                            `[nft][src][components][pages][EmiOutstandingPay][waitTransactionReceipt] Error on transaction receipt 2 ${transactionHash}: ${error}`
                        );
                        swal({
                            icon: "error",
                            title: "Cancelled",
                            text: error.message,
                            showConfirmButton: true,
                            showCancelButton: false,
                            allowOutsideClick: true,
                        });
                        setIsAlreadyApproved(false);
                    });
            }
        }, 1000);
    };

    const refreshPage = () => {
        window.location.reload();
    };

    const payPendingEMI = async () => {
        console.log(
            `[nft][src][components][pages][modal][payFirstEMI] Initiated`
        );

        let payToken = paymentToken;

        console.log(
            `[nft][src][components][pages][modal][payFirstEMI] Selected Token`,
            payToken
        );

        let web3 = new Web3(window.ethereum);
        let accounts = await web3.eth.getAccounts();
        console.log(
            `[nft][src][components][pages][modal][payFirstEMI] accounts`,
            accounts
        );

        let ERC20 = await new web3.eth.Contract(erc20Abi, payToken);
        let userBalance = await ERC20.methods.balanceOf(connectedWallet).call();
        console.log(
            `[nft][src][components][pages][modal][payFirstEMI] userBalance`,
            userBalance
        );

        let userBalanceBN = new BigNumber(userBalance);
        // console.log(userBalanceBN, "userBalanceBN");

        let decimal = await ERC20.methods.decimals().call();
        // console.log("decimal", decimal);

        let decimalBN = new BigNumber(decimal);
        // console.log("decimalBN", decimalBN);

        let baseBN = new BigNumber(10);
        // console.log("baseBN", baseBN);

        let balanceToPay = new BigNumber(payingAmount);
        // console.log("balanceToPay", balanceToPay);

        let exponentiate = baseBN.exponentiatedBy(decimalBN);
        // console.log("exponentiate", exponentiate);

        let balanceToPayBN = new BigNumber(balanceToPay).multipliedBy(
            exponentiate
        );
        console.log(
            `[nft][src][components][pages][modal][payFirstEMI] Pay now`,
            balanceToPayBN.toString()
        );

        let res = userBalanceBN.comparedTo(balanceToPayBN);
        console.log(
            `[nft][src][components][pages][modal][payFirstEMI] Has enough balance`,
            res
        );

        let amountToPayNow = balanceToPayBN.toString();

        if (res === -1) {
            swal({
                icon: "error",
                title: "Failed",
                text: "Insufficient Funds. Please topup your Balance to proceed for payment",
                showConfirmButton: true,
                showCancelButton: false,
                allowOutsideClick: true,
            });
            return;
        }

        try {
            let EMI = await new web3.eth.Contract(
                emiAbi,
                constants.NITROMORTGAGE
            );

            console.log(
                collectionInfo.collection,
                collectionInfo.emiId,
                payToken,
                amountToPayNow
            );

            await EMI.methods
                .payEMI(
                    collectionInfo.collection,
                    collectionInfo.emiId,
                    payToken,
                    amountToPayNow
                )
                .send({ from: accounts[0] })
                .on("transactionHash", function (hash) {
                    console.log(
                        `[nft][src][components][components][modal][payNow] transactionHash`,
                        hash
                    );
                    swal({
                        icon: "info",
                        title: "In progress",
                        text: "Transaction initiated, please wait for the transaction to complete!",
                        showConfirmButton: true,
                        showCancelButton: false,
                        allowOutsideClick: true,
                    });
                    setIsPayTxAvailable(true);
                    let txHash = `${constants.EXPLORER_URL}/tx/${hash}`;
                    setPayTx(txHash);
                    waitTransactionReceipt(
                        hash,
                        "emi",
                        0,
                        function (err, receipt) {
                            if (err != null) {
                                return;
                            }
                        }
                    );
                })
                .on("error", function (error, receipt) {
                    console.log(
                        `[nft][src][components][components][modal][payNow] transactionHash error 1`,
                        error
                    );
                    swal({
                        icon: "error",
                        title: "Failed",
                        text: "Transaction cancelled. Please try again!",
                        showConfirmButton: true,
                        showCancelButton: false,
                        allowOutsideClick: true,
                    });
                    return;
                });
        } catch (error) {
            console.log(
                `[nft][src][components][components][modal][payNow] transactionHash error 2`,
                error
            );
            swal({
                icon: "error",
                title: "Failed",
                text: "Something went wrong. Please try again!",
                showConfirmButton: true,
                showCancelButton: false,
                allowOutsideClick: true,
            });
        }
    };

    useEffect(() => {
        getWalletConnectionStatus();
        if (isWalletConnected == true || isWalletConnected == "true") {
            isNFTContractApproved(paymentToken);
        }
    });

    return (
        <div className="emi-screen ">
            {/*Outstanding Payment */}
            <div className="outstanding-payment">
                {/* <h3 className="fw-600">Due to Pay*</h3> */}

                <div className="field-outstanding">
                    <p className="mb-1">
                        {" "}
                        Due to Pay* ({constants.PAY_TOKEN_NAME})
                    </p>
                    <input
                        type="text"
                        value={`${collectionInfo.amountDue}`}
                        disabled
                    />
                </div>
                <div className="field-outstanding">
                    <p className="mb-1">
                        {" "}
                        Enter Amount to Pay ({constants.PAY_TOKEN_NAME})
                    </p>
                    <input
                        type="text"
                        placeholder="Enter amount "
                        value={payingAmount}
                        onChange={handleChange}
                    />
                </div>

                <div className="field-outstanding">
                    <p className="mb-1">Choose Payment Token</p>
                    <select
                        name="totalNFM"
                        id="totalNFM"
                        onChange={(e) => handlePaymentTokensChange(e)}
                    >
                        {choosePaymentTokenOptions.map((option, i) => (
                            <option key={i} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>

                {/* <div className="field-outstanding">
                    <p className="mb-1">Choose Payment Method</p>
                    <select name="totalNFM" id="totalNFM">
                        <option value={1}>WBTC.e</option>
                        <option value={2}>WETH.e</option>
                        <option value={4}>DAI.e</option>
                        <option value={3}>WAVAX</option>
                        <option value={5} selected>
                            USDC.e
                        </option>
                        <option value={6}>USDT.e</option>
                    </select>
                </div> */}

                {isAlreadyApproved == true && (
                    <div className="text-right">
                        <button
                            className="fw-600 gradient-butto-2 connect-wallet-btn"
                            onClick={payPendingEMI}
                            disabled={payingAmount < 1 && true}
                            style={{ filter: payingAmount < 1 && 'brightness(80%)'}}
                            style={{ cursor: payingAmount < 1 && "not-allowed"}}
                        >
                            Pay EMI
                        </button>
                    </div>
                )}

                {isAlreadyApproved == false && (
                    <div className="text-right">
                        <button
                            className="fw-600 gradient-butto-2 connect-wallet-btn"
                            onClick={approveNFTContract}
                        >
                            Approve
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default EmiDueToPay;
